import { DateTime } from 'luxon';

export function formatLabel(value: string) {
  const date = DateTime.fromFormat(value, 'MM/yyyy');
  return date.toFormat('MMMM yyyy');
}

export function formatDescription(value: string) {
  const date = DateTime.fromFormat(value, 'MM/yyyy');
  const start = date.startOf('month');
  const end = date.endOf('month');
  return `${start.toFormat('D')} - ${end.toFormat('D')}`;
}

export function formatAmount(value: number) {
  return new Intl.NumberFormat(navigator.language, {
    currency: 'AUD',
    style: 'currency',
  }).format(value);
}
